import { Outlet, useNavigate } from "react-router-dom";
import { NavRail } from "./NavRail";
import { MenuBar } from "./MenuBar";
import { CommandPalette, useCommandPaletteToggle } from "./CommandPalette";
import { StatusBar } from "./StatusBar";
import { useGridPrefsStore } from "../store/gridPrefsStore";
import clsx from "clsx";

/** Root layout: nav rail + menu + workspace + footer. `.atlas-shell` is popup parent for AG Grid. */
export function AppShell() {
  const navigate = useNavigate();
  const { open, setOpen } = useCommandPaletteToggle();
  const theme = useGridPrefsStore((s) => s.theme);

  return (
    <div
      className={clsx(
        "atlas-shell flex h-screen w-screen overflow-hidden bg-bg font-mono text-[var(--fg-primary,#e5e5e5)] text-xs",
        theme === "light" && "atlas-theme-light",
      )}
    >
      <NavRail />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden border-l border-border">
        <MenuBar onOpenCommandPalette={() => setOpen(true)} />
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </main>
        <StatusBar />
      </div>

      <CommandPalette
        open={open}
        onClose={() => setOpen(false)}
        onNavigate={(path) => {
          navigate(path);
        }}
      />
    </div>
  );
}
